import React from 'react';
import { addBodyClasses } from "../utils";

const queryString = require('query-string');

function RAFSurge({bonus = '40%'}) {
  const parsed = queryString.parse(window.location.search);
  const inviteCode = parsed.invite_code || '???????';

  const useShareSheet = navigator.share != null;

  const share = (event) => {
    const text = `I earn with the MSR app by sharing data. Use my code ${inviteCode} to DOUBLE your welcome bonus!`;
    const url = `https://go.measureprotocol.com/i/${inviteCode}`;

    if (useShareSheet) {
      navigator.share({
        text: text,
        url: url,
      });
    } else {
      navigator.clipboard.writeText(text + ' ' + url);
    }
  };

  addBodyClasses(['generic-landing-page', 'raf-page'])();

  return (
    <>
      <div className="purple-header-strip">
        <h1>Your Referral Bonus</h1>
        {/*<p className="raf-subtitle">Refer and earn 2X bonus for 4 weeks!</p>*/}
      </div>
      <img
        className="ticket"
        alt="Earn double bonus!"
        src="/img/ticket.png"
        srcSet="/img/ticket@2x.png 2x, /img/ticket@3x.png 3x"
      />
      <p className="your-code-label" onClick={share}>Your code</p>
      <p className="your-code" onClick={share}>{inviteCode}</p>
      <p className="raf-hint" onClick={share}>(tap to {useShareSheet ? 'share' : 'copy'})</p>

      <p className="offer-details">Earn <b>{bonus}</b> every time your friends complete
        a task + they get a double joining reward!</p>

      {useShareSheet &&
        <div className="action-button">
          <a className="btn btn-primary" href="#" onClick={share}>Share now</a>
        </div>
      }
    </>
  );
}

export default RAFSurge;
